<div class="modal-body exclude-modal-styling">
    <ws-ace-loader [marginBottom]="50" [show]="!taxRateArea" [size]="4" [hasOverlay]="false"></ws-ace-loader>
    @if (taxRateArea) {
        <div class="ws-flex-container-vertical ws-stretch">
            <div class="ws-section">
                <div class="ws-section__header">
                    <h4 class="ws-section__header__title">Tax Rate Area</h4>
                    <div class="ws-section__header__actions">
                        @if (canEdit) {
                            <div class="ws-section__header__actions__item">
                                @if (cloning) {
                                    <i class="fa fa-spinner fa-pulse fa-2x me-4"></i>
                                }
                                @if (!editMode) {
                                    <button (click)="goToEditMode()"
                                        [disabled]="cloning"
                                        class="ace-btn btn-sm btn-primary has-icon"
                                        title="Edit"
                                        type="button">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                }
                                @if (!editMode) {
                                    <button (click)="delete()"
                                        [disabled]="cloning || !taxRateArea.mayBeDeleted"
                                        class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                        type="button"
                                        helpTooltip
                                        [helpContentId]="deleteButtonHelpContentId">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                }
                                @if (editMode && taxRateArea.taxRateAreaId) {
                                    <button (click)="cancel()"
                                        [disabled]="saving"
                                        class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                        title="Cancel"
                                        type="button">
                                        <i class="fa fa-close"></i>
                                    </button>
                                }
                                @if (!editMode && taxRateArea.taxRateAreaId) {
                                    <button (click)="clone()"
                                        [disabled]="saving || cloning"
                                        class="ace-btn btn-sm btn-primary has-icon"
                                        title="Clone"
                                        type="button">
                                        <i class="fa fa-clone"></i>
                                    </button>
                                }
                            </div>
                        }
                        <div class="ws-section__header__actions__item">
                            <entity-attachments [(hasAttachments)]="taxRateArea.hasAttachments"
                                                [isNestedModal]="true"
                                                [modalData]="attachmentsModel"
                                                buttonClass="ace-btn btn-sm btn-primary">
                            </entity-attachments>
                            <entity-comments [(hasComments)]="taxRateArea.hasComments"
                                             [isNestedModal]="true"
                                             [modalData]="commentsModel"
                                             buttonClass="ace-btn btn-sm btn-primary">
                            </entity-comments>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ws-flex-container-vertical ws-stretch">
                <div class="ws-flex-container-horizontal">
                    <div class="card panel-flat-color primary-panel flex-panel pb-0">
                        <div class="panel-flat-header">
                            <h3>Info</h3>
                        </div>
                        <div class="panel-flat-body ws-flex-container-vertical">
                            <div class="ws-flex-auto w-100 h-100 d-flex justify-content-around">
                                <div>
                                    <table [class.is-edit-mode]="editMode" class="tax-rate-area-info">
                                        <tr>
                                            <td>Name:</td>
                                            <td>
                                                @if (!editMode) {
                                                    <span>{{ taxRateArea.name }}</span>
                                                }
                                                @if (editMode) {
                                                    <input [(ngModel)]="taxRateArea.name"
                                                           class="form-control"
                                                           maxlength="100"
                                                           type="text">
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Code:</td>
                                            <td>
                                                @if (!editMode) {
                                                    <span>{{ taxRateArea.code }}</span>
                                                }
                                                @if (editMode) {
                                                    <input [(ngModel)]="taxRateArea.code"
                                                           class="form-control"
                                                           maxlength="50"
                                                           type="text">
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                    <div class="mt-4">
                                        @if (taxRateArea.disabled) {
                                            <div class="checkbox">
                                                <label>
                                                    <input [(ngModel)]="taxRateArea.disabled"
                                                           [disabled]="!editMode"
                                                           type="checkbox"> Disabled
                                                </label>
                                            </div>
                                        }
                                        @if (editMode && !taxRateArea.disabled) {
                                            <button [outsideClick]="true"
                                                [popover]="endYearPopover"
                                                class="ace-btn btn-primary btn-danger btn-sm m-0"
                                                container="body"
                                                placement="right">Disable
                                            </button>
                                        }
                                    </div>
                                </div>
                                <table [class.is-edit-mode]="editMode" class="tax-rate-area-address">
                                    <tr>
                                        <td>Address:</td>
                                        <td>
                                            <address-view-edit [address]="taxRateArea.address"
                                                               [isEditMode]="editMode"
                                                               [isSmall]="true"
                                                               [readOnlyState]="true">
                                            </address-view-edit>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card panel-flat-color secondary-panel flex-panel tax-authorities-list">
                    <div class="panel-flat-header">
                        <h3>Tax Authorities</h3>
                    </div>
                    <div class="panel-flat-body ws-flex-container-vertical">
                        @if (!hideAddCollectorButton && editMode) {
                            <div class="btn-group position-absolute"
                                container="body"
                                dropdown
                                placement="bottom right"
                                style="right: 20px;">
                                <button [attr.disabled]="shouldDisableAddCollector"
                                        class="ace-btn btn-primary btn-sm dropdown-toggle"
                                        dropdownToggle
                                        type="button">
                                    Add Collector <span class="caret"></span>
                                </button>
                                <ul *dropdownMenu class="dropdown-menu dropdown-menu-end collectors" role="menu">
                                    @for (collector of taxRateArea.collectors; track collector) {
                                        @if (!collector.isTab) {
                                            <li role="menuitem">
                                                <a (click)="addCollector(collector)"
                                                   class="dropdown-item pointer">{{ collector.name }}</a>
                                            </li>
                                        }
                                    }
                                </ul>
                            </div>
                        }
                        @if (atLeastOneTab) {
                            <div class="ws-flex-auto w-100 h-100 d-flex flex-column justify-content-between">
                                <tabset>
                                    @for (collector of taxRateArea.collectors; track collector) {
                                        @if (collector.isTab) {
                                            <tab (deselect)="collector.active = false"
                                                 (selectTab)="collector.active = true;"
                                                 [active]="collector.active"
                                                 [customClass]="taxRateArea.collectorId ? 'collector-tra' : ''"
                                                 [heading]="collector.name">
                                                @if (editMode) {
                                                    <div class="mb-2 col-4">
                                                        <div class="input-group scrollable-typeahead">
                                                            <input (typeaheadOnSelect)="addTaxAuthority($event)"
                                                                   [(ngModel)]="typeaheadTAToAdd"
                                                                   [disabled]="!collector.taxAuthorities?.length"
                                                                   [typeaheadMinLength]="0"
                                                                   [typeaheadOptionsLimit]="100"
                                                                   [typeaheadScrollable]="true"
                                                                   [wsTypeahead]="filterTAs()"
                                                                   class="form-control"
                                                                   container="body"
                                                                   placeholder="Add Tax Authority..."
                                                                   typeaheadOptionField="name">
                                                            <button (click)="openBrowseModal()"
                                                                    [disabled]="!collector.taxAuthorities?.length"
                                                                    class="ace-btn has-icon btn-secondary"
                                                                    type="button">
                                                                <i class="fa fa-binoculars"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                                <div class="tra-table">
                                                    <table class="table table-condensed tax-rate-authorities">
                                                        <thead>
                                                            <tr>
                                                                <th>Code</th>
                                                                <th>Tax Authority Name</th>
                                                                <th>Category</th>
                                                                <th class="ws-text-align-center">Tax Year Begin</th>
                                                                <th class="ws-text-align-center">Tax Year End</th>
                                                                <th></th>
                                                                @for (year of years; track year) {
                                                                    <th class="ws-text-align-right">{{ year }}
                                                                    </th>
                                                                }
                                                            </tr>
                                                        </thead>
                                                        @for (
                                                            taxAuthority of collector.taxAuthorities; track taxAuthority) {
                                                            @for (
                                                                detail of taxAuthority.taxRateAreaTaxAuthorityDetails; track detail) {
                                                                @if (detail.efAction !== 'delete') {
                                                                    <tr>
                                                                        <td>{{ taxAuthority.code }}</td>
                                                                        <td>{{ taxAuthority.name }}</td>
                                                                        <td>{{ getCategory(taxAuthority.taxAuthorityCategoryId) }}</td>
                                                                        <td class="ws-text-align-center">
                                                                            @if (!editMode) {
                                                                                <span
                                                                                >{{ detail.yearBegin || 'Infinite' }}</span>
                                                                            }
                                                                            @if (editMode) {
                                                                                <select
                                                                                    (change)="yearBeginChange(detail, taxAuthority)"
                                                                                    [(ngModel)]="detail.yearBegin"
                                                                                    [disabled]="loadingProjections"
                                                                                    class="form-select form-select-sm d-inline-block">
                                                                                    <option [ngValue]="null">Infinite
                                                                                    </option>
                                                                                    @for (
                                                                                        year of taxYearBeginEndOptions; track year) {
                                                                                        <option
                                                                                            [ngValue]="year">{{ year }}
                                                                                        </option>
                                                                                    }
                                                                                </select>
                                                                            }
                                                                        </td>
                                                                        <td class="ws-text-align-center">
                                                                            @if (!editMode) {
                                                                                <span
                                                                                >{{ detail.yearEnd || 'Infinite' }}</span>
                                                                            }
                                                                            @if (editMode) {
                                                                                <select
                                                                                    (change)="yearEndChange(detail, taxAuthority)"
                                                                                    [(ngModel)]="detail.yearEnd"
                                                                                    [disabled]="loadingProjections"
                                                                                    class="form-select form-select-sm d-inline-block">
                                                                                    <option [ngValue]="null">Infinite
                                                                                    </option>
                                                                                    @for (
                                                                                        year of taxYearBeginEndOptions; track year) {
                                                                                        <option
                                                                                            [ngValue]="year">{{ year }}
                                                                                        </option>
                                                                                    }
                                                                                </select>
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <div>
                                                                                <button (click)="removeTaxRateAreaTaxAuthorityDetail(taxAuthority, detail)"
                                                                                        [class.invisible]="!editMode"
                                                                                        [disabled]="loadingProjections"
                                                                                        class="ace-btn has-icon btn-primary btn-danger btn-sm m-0">
                                                                                    <i class="fa fa-trash"></i>
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                        @for (year of years; track year) {
                                                                            <td
                                                                                [class.not-actual]="getYearEstimated(taxAuthority, year)"
                                                                                class="ws-text-align-right">
                                                                                {{ getYearRate(taxAuthority, detail, year) }}
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                }
                                                            }
                                                        }
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            @for (year of years; track year) {
                                                                <td
                                                                    [class.not-actual]="getTotalEstimated(collector.taxAuthorities, year)"
                                                                    class="ws-text-align-right tra-totals-row">
                                                                    {{ getTotalRateForDisplay(collector.taxAuthorities, year) }}
                                                                </td>
                                                            }
                                                        </tr>
                                                    </table>
                                                </div>
                                            </tab>
                                        }
                                    }
                                </tabset>
                                <div class="tax-authorities-actions mt-2">
                                    <div>
                                        <label>
                                            <input (ngModelChange)="sortData()"
                                                   [(ngModel)]="groupByCategory"
                                                   type="checkbox">
                                            Group by Category
                                        </label>
                                    </div>
                                    <!-- <div>
                                    <div>Order:</div>
                                    <div>
                                      <label>
                                        <input type="radio" value="alpha" [(ngModel)]="orderBy" (ngModelChange)="orderByChanged()"> Alphabetical
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input type="radio" value="manual" [(ngModel)]="orderBy" (ngModelChange)="orderByChanged()"> Manual
                                      </label>
                                    </div>
                                  </div> -->
                                    <show-tax-year (showTaxYearChanged)="showTaxYearChanged()"
                                                   [(taxYearBegin)]="taxYearBegin"
                                                   [(taxYearsPrior)]="taxYearsPrior">
                                    </show-tax-year>
                                </div>
                            </div>
                        }
                        @if (!editMode && !atLeastOneTab) {
                            <div class="ws-text-align-center">
                                <h4><em>No Collectors Added</em></h4>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
</div>

@if (taxRateArea) {
    <div class="modal-footer pt-0">
        @if (saving) {
            <i class="fa fa-spinner fa-pulse fa-2x me-4"></i>
        }
        @if (editMode) {
            <button (click)="save()" [disabled]="saving || !taxRateArea?.name"
                    class="ace-btn btn-primary">Save
            </button>
        }
        <button (click)="closeModal()" class="ace-btn btn-secondary">Close</button>
    </div>
}

<ng-template #endYearPopover>
    <div class="mb-4">
        <label>Enter Tax Year End (All tax Authorities)</label>
        <select (change)="disableTaxRateArea()" [(ngModel)]="globalYearEnd"
                class="form-select form-select-sm d-inline-block">
            @for (year of taxYearBeginEndOptions; track year) {
                <option [ngValue]="year">{{ year }}</option>
            }
        </select>
    </div>
</ng-template>
